import { daUtils } from '../_utils';
import {
    IApiResponse,
    IDatasourceRequest,
    IItemIdRequest,
    IItemSIdRequest,
    IPafExpiryRequest,
    IPaf,
    IPafFile,
    IItemIdsRequest,
    IMuiDataRequest,
} from "./types";
import { API_PAF_BASE_URI } from "./index";

const API_PAF_GET = `${API_PAF_BASE_URI}/pafs/filter/`;
const API_PAF_GET_BY_ID = `${API_PAF_BASE_URI}/pafs/{paf_id}/`;
const API_PAF_GET_BY_SID = `${API_PAF_BASE_URI}/pafs/sid/{paf_sid}/`;
const API_PAF_ADD = `${API_PAF_BASE_URI}/pafs/`;
const API_PAF_UPD = `${API_PAF_BASE_URI}/pafs/{paf_id}/`;
const API_PAF_DEL = `${API_PAF_BASE_URI}/pafs/delete/`;
const API_PAF_PENDING = `${API_PAF_BASE_URI}/pafs/pending/`;
const API_PAF_EXPIRY_RECENT = `${API_PAF_BASE_URI}/pafs/expiry/recent/{expiry_days}/`;
const API_PAF_EXPIRY_SOON = `${API_PAF_BASE_URI}/pafs/expiry/soon/{expiry_days}/`;

const API_PAF_FILES_GET_BY_PAF_ID = `${API_PAF_BASE_URI}/pafs/{paf_id}/files/`;
const API_PAF_FILES_DEL = `${API_PAF_BASE_URI}/pafs/files/delete/`;
const API_PAF_FILES_UPLOAD = `${API_PAF_BASE_URI}/pafs/files/upload/`;

// Presigned PAF Sign endpoints (no authentication required)
const API_PAF_SIGN_VERIFY = `${API_PAF_BASE_URI}/pafs/sign/{token}/`;
const API_PAF_SIGN_SUBMIT = `${API_PAF_BASE_URI}/pafs/sign/{token}/submit/`;
const API_PAF_USER_GET = `${API_PAF_BASE_URI}/user/{user_id}/`;
const API_PAF_PDF_DOWNLOAD = `${API_PAF_BASE_URI}/pafs/{paf_id}/pdf/`;


const get = async (
    options: IMuiDataRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'POST',
            body: JSON.stringify(options)
        };
        const url = API_PAF_GET;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const get_by_id = async (
    options: IItemIdRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'GET',
            cache: "no-cache",
        };
        const id = options.id.toString();
        const url = API_PAF_GET_BY_ID.replace('{paf_id}', id);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const get_by_sid = async (
    options: IItemSIdRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'GET',
            cache: "no-cache",
        };
        const sid = options.sid;
        const url = API_PAF_GET_BY_ID.replace('{paf_sid}', sid);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const add = async (
    options: IPaf,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'POST',
            body: JSON.stringify(options)
        };
        const url = API_PAF_ADD;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const update = async (
    options: IPaf,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'PUT',
            body: JSON.stringify(options)
        };
        const id = options.paf_id!.toString();
        const url = API_PAF_UPD.replace('{paf_id}', id);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const remove = async (
    options: IItemIdsRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions = {
            method: 'DELETE',
            body: JSON.stringify(options)
        };
        const url = API_PAF_DEL;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const get_pending = async (
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'GET',
            cache: "no-cache",
        };
        const url = API_PAF_PENDING;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const get_expiry_recent = async (
    options: IPafExpiryRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'GET',
            cache: "no-cache",
        };
        const expiry_days = options.expiry_days.toString();
        const url = API_PAF_EXPIRY_RECENT.replace('{expiry_days}', expiry_days);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const get_expiry_soon = async (
    options: IPafExpiryRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'GET',
            cache: "no-cache",
        };
        const expiry_days = options.expiry_days.toString();
        const url = API_PAF_EXPIRY_SOON.replace('{expiry_days}', expiry_days);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const files_get_by_paf_id = async (
    options: IItemIdRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'GET',
            cache: "no-cache",
        };
        const id = options.id.toString();
        const url = API_PAF_FILES_GET_BY_PAF_ID.replace('{paf_id}', id);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const files_add = async (
    options: FormData,
    auth_token: string | undefined = undefined) => {
    try {

        const requestOptions: RequestInit = {
            method: 'POST',
            body: options
        };
        const url = API_PAF_FILES_UPLOAD;
        const resp: IApiResponse = await daUtils.daFetchUpload(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const files_remove = async (
    options: IItemIdsRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions = {
            method: 'DELETE',
            body: JSON.stringify(options)
        };
        const url = API_PAF_FILES_DEL;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const get_by_user_id = async (
    user_id: string | number,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'GET',
            cache: "no-cache",
        };
        const id = user_id.toString();
        const url = API_PAF_USER_GET.replace('{user_id}', id);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

/**
 * Verify a presigned PAF sign token and get PAF data (no auth)
 */
const sign_verify = async (token: string) => {
    try {
        const requestOptions: RequestInit = {
            method: 'GET',
            cache: "no-cache",
            headers: {
                'Content-Type': 'application/json',
            },
        };
        const url = API_PAF_SIGN_VERIFY.replace('{token}', token);
        const response = await fetch(url, requestOptions);
        const resp: IApiResponse = await response.json();

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        return {
            success: false,
            message: e.message,
            error: [e.message],
            count: 0,
            data: null
        };
    }
}

const sign_submit = async (token: string, signatureData: {
    list_admin_signature_attest: boolean;
    list_admin_signature_text: string;
}) => {
    try {
        const requestOptions: RequestInit = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(signatureData)
        };
        const url = API_PAF_SIGN_SUBMIT.replace('{token}', token);
        const response = await fetch(url, requestOptions);
        const resp: IApiResponse = await response.json();

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        return {
            success: false,
            message: e.message,
            error: [e.message],
            count: 0,
            data: null
        };
    }
}

const pdf_download = async (paf_id: string | number, auth_token: string | undefined = undefined, filename?: string) => {
    try {
        const id = paf_id.toString();
        const url = API_PAF_PDF_DOWNLOAD.replace('{paf_id}', id);

        // Fetch PDF as blob (not JSON)
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${auth_token}`,
            },
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || `Failed to download PDF: ${response.status} ${response.statusText}`);
        }

        // Get the blob and create download link
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;

        // Get filename from Content-Disposition header or use provided/default
        let downloadFilename = filename || `PAF_${id}.pdf`;
        const contentDisposition = response.headers.get('Content-Disposition');
        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
            if (filenameMatch && filenameMatch[1]) {
                downloadFilename = filenameMatch[1].replace(/['"]/g, '');
            }
        }

        link.download = downloadFilename;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);

        return {
            success: true,
            message: 'PDF downloaded successfully',
            error: [],
            count: 1,
            data: null
        } as IApiResponse;
    }
    catch (e: any) {
        return {
            success: false,
            message: e.message || 'Failed to download PDF',
            error: [e.message || 'Failed to download PDF'],
            count: 0,
            data: null
        } as IApiResponse;
    }
}

export const pafApi = {
    get,
    get_by_id,
    get_by_user_id,
    add,
    update,
    remove,
    get_pending,
    get_expiry_recent,
    get_expiry_soon,
    files_get_by_paf_id,
    files_add,
    files_remove,
    sign_verify,
    sign_submit,
    pdf_download,
};